import { motion } from "framer-motion";
import styled from "styled-components";
import { Flex } from "../Layouts/styles";
import { fadingTextColor } from "../../styles/styles";

export const ExpandableContent = styled(motion.div)`
  overflow: hidden;
  position: relative;
`;

export const ToggleButton = styled(Flex)`
  margin-top: 1vw;
  gap: 0.25vw;
  align-items: flex-end;
  background-color: transparent;
  border: none;
  cursor: pointer;
  justify-content: space-between;
  user-select: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: unset;
    justify-content: unset;
  }
`;

export const PixelTitle = styled("h1")`
  font-family: greyBeard !important;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 16em;
    margin-top: 2vw;
  }
`;

export const AccordionContainer = styled("div")`
  border-top: 1px solid white;
  padding-bottom: 1vw;

  &:last-child {
    border-bottom: 1px solid white;
  }
`;

export const MiniTitle = styled("h4")`
  color: ${fadingTextColor};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 8em;
    margin-left: 13vw;
    margin-top: 6vw;
  }
`;
